import React, {useState,useEffect} from "react";
import {
    BrowserRouter as Router,
    withRouter, useParams  
} from "react-router-dom";

import customCampaignLogic from "../../../layouts/logics/custom-campaign-logic";
import UserForm from "../../user-form";
import ServerApi from "../../../services/server-api-service";
import ConfigurationService from "../../../services/configuration-service";
import Parser from 'html-react-parser';
import Slider from "react-slick";
import Helmet from 'react-helmet';
import ReactPlayer from "react-player";
// import ActivityWatcher from '../../../functions/user-activity/user-activity.js'
import { default as vimg } from "../../../elements/images/vimg.svg"; 

import '../../custom-landing-page/custom-landing-page-style.css';
import './miami-move-page-style.css';
import '../../project-company-page/project-company-page-style.css';

import '../../../lib/slick-1.8.1/slick.css';
import '../../../lib/slick-1.8.1/slick-theme.css';
import HOne from "../../h-one";
import { Description } from "@mui/icons-material";



function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    const nextIcon = require('../../../elements/icons/next_icon.png');
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <img src={nextIcon} alt="Next" />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    const prevIcon = require('../../../elements/icons/prev_icon.png');
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <img src={prevIcon} alt="Prev" />
        </div>
    );
}


function MiamiMovePage(props){

    const serverApi = new ServerApi();
    const configurationService = new ConfigurationService();
    const {saveState,width, dictionary, country,setStateLogic, height, mobileVerison, openModal, watcher} = props;
    const params = useParams();

    const [customDictionary, setCustomDictionary] = useState(null);
    const [contactForm,setContactForm] = useState({
            userComment: "",
            userEmail: "",
            userFullName: "",
            userPhone: "",
            project: ""
        });

    const [gallery, setGallery] = useState([]);
    // const watcher = new ActivityWatcher('openMessageModal'); 
    const lang = configurationService.getCurrentLanguagePrefix();

    const smart_luxe_logo_small = require('../../../elements/images/logo_positive_left.png');
    const time_to_act = require('../../../elements/images/movemiami/welcome_florida_top.jpg');
    const proj_1 = require('../../../elements/images/movemiami/slider_1.jpg');
    const proj_2 = require('../../../elements/images/movemiami/slider_2.jpg');
    const proj_3 = require('../../../elements/images/movemiami/slider_3.jpg');
    const proj_4 = require('../../../elements/images/movemiami/slider_4.jpg');
    const logo = require('../../../elements/images/movemiami/welcome_florida_but.png');
  
    useEffect(()=>{

        Promise.all([serverApi.getCustomDictionary('movemiami',lang), serverApi.getCustomDictionary('campaigns',lang)])
        .then((res)=>{
            let newDictionary = {...res[0], ...res[1]};
            setCustomDictionary(newDictionary);
            setStateLogic({
                footerLogo: logo,
                customDictionary:newDictionary,
            });
            setContactForm({
                ...contactForm,
                project: newDictionary.campaign_name
            })
            
            setGallery([
                {src:proj_1,description:newDictionary.slider_slide_1},
                {src:proj_2,description:newDictionary.slider_slide_2},
                {src:proj_3,description:newDictionary.slider_slide_3},
                {src:proj_4,description:newDictionary.slider_slide_4}
            ]);
        })

        if(saveState){
            saveState({
                currentPage:"CustomLandingPage",
                isVisibleFooter: false,
                isVisibleHeader: false,
            })
        }
        return(()=>{
             if(saveState){
                saveState({
                    currentPage:"CustomLandingPage",
                    isVisibleFooter: true,
                    isVisibleHeader: true,
                })
            }
        })
    },[])

    const clearForm = () =>{
        setContactForm({
            userComment: "",
            userEmail: "",
            userFullName: "",
            userPhone: ""
        })
    }

    const handleInput = (event) =>{
        setContactForm({
            ...contactForm,
            [event.target.name]: event.target.value
        })
    }

    const renderDot = () => {
        return (
            <div className={'CustomDot'}></div>
        )
    }


    const renderSliderTop =() => {

        const settingsSlider = {
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            slidesToShow: 1,//5
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        arrows: true,
                        dots: false
                    }
                },
            ],
        };
        return (
            <>
                <Slider 
                    {...settingsSlider}
                    // ref={slider => (this.refTopSlider = slider)}
                    className={'ProjectCompanySlider'}
                    customPaging={renderDot}
                >
                    {customDictionary.gallery.map((img, index) => {
                        return (
                            <div className={'ItemBox'} key={`Default ${index}`}>
                                <img className={'Item'} src={img['src']} alt={img}></img>
                                <div className={"SlideDescription"}>{img['slide_description']}</div>
                            </div>
                        )
                    })}
                </Slider>
            </>
        )
    }

    const renderButtons = () => {
        const contactWAicon = require('../../../elements/icons/wa_icon.svg').default;

        return (
            <>
                <a target="_blank" href={`https://wa.me/${customDictionary.landing_wa_number}?text=${customDictionary.landing_wa_text}`} className='Button'><img className="IconWa" src={contactWAicon} alt={'phone'} /></a> 
                <div onClick={() => {openModal('isVisibleMessage') }} className='Button'>{customDictionary.submit} </div>
            </>
        )

    }


    const settingsSlider = {
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        arrows: true,
        variableWidth: true,

        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1, //4
                    arrows: true,
                    variableWidth: false,
                    adaptiveHeight: true,
                    centerMode: false,
                }
            }
        ],
    };

 

    let classPage =  '';
    if(!customDictionary) return null;
    if(params.lang = 'he') classPage = "hePage"

    // Calss for sticky buttons
    let sticky_buttons_class = 'Buttons StickyButtons';

    let ButForm = document.getElementsByClassName('ButtomForm')[0];
    let form_position_from_top = 1;
    if (ButForm) {
        let rect = ButForm.getBoundingClientRect();
        form_position_from_top = rect.top;
    }

    if (form_position_from_top - height + 200 < 0) {
        sticky_buttons_class = 'Buttons';
    }


    return(
        <div className={' Page CompanyProject customCampaigns ' + classPage} id={"Movemiami"}>
                <Helmet>
                            <title> {customDictionary.title} | Smart Luxe</title>
                  
                </Helmet>
                 <div className={"header"}>
     
                    <div className={"smartLuxeLogo"}>
                        <img src={smart_luxe_logo_small} alt={""} />
                    </div>
                    <div className="slogan">
                        {Parser(customDictionary.slogan)}
                    </div>
                </div>

                <div className={"TopPart"}>
                        <div className={"TopSlider"} style={{ color: 'white' }}>
                            {/* <div className={"MiamiFl"}>{customDictionary.slider_slide_1}</div> */}

                            {width > 1000 ? (
                                <div className={"TopHeader"}>
                                    {/* <HOne align={"left"} title={data.name} /> */}
                                    {customDictionary.title && <div className={"Slogan"}>{customDictionary.title}</div>}
                                </div>
                            ) : (
                                <div className={"TopHeaderMobile"}>
                                    <div className={'Slogan'}>
                                        <HOne align={"center"} title={customDictionary.title} />
                                    </div>

                                    <div className={sticky_buttons_class}>
                                        {renderButtons()}
                                    </div>




                                </div>
                            )}



                            {renderSliderTop()}
                        </div>

                        {/* {width > 1000 ? ( */}
                        {width > 1000 ? (
                            <div className={"Form"}>

                                <HOne addclass={"xsmall"} align={"center"} line={"none"} title={`${customDictionary.request}`} />
                                {/* <img src={logo} className={"ProjectLogo"} alt=""></img> */}
                                {/* <img src={tempMissoniLogo} alt="" className={"ProjectLogo"} /> */}
                                {/*${data.name}*/}

                                {customDictionary.urgency ?
                                    <React.Fragment>
                                        <div className={"FormText"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                                <defs>
                                                    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                                        <stop offset="0" stopColor="#a96903" />
                                                        <stop offset="0.258" stopColor="#aa6a02" />
                                                        <stop offset="0.352" stopColor="#b07102" />
                                                        <stop offset="0.418" stopColor="#b97d02" />
                                                        <stop offset="0.472" stopColor="#c78e01" />
                                                        <stop offset="0.518" stopColor="#daa401" />
                                                        <stop offset="0.557" stopColor="#f0be00" />
                                                        <stop offset="0.579" stopColor="#ffd100" />
                                                        <stop offset="1" stopColor="#a96903" />
                                                    </linearGradient>
                                                </defs>
                                                <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                                    <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                                </g>
                                            </svg>
                                            <div className={"Urgency"}>{customDictionary.urgency}</div>
                                        </div>
                                    </React.Fragment>
                                    : (null)
                                }

                                <UserForm
                                    thankModal={true}
                                    message={dictionary.thank_you_deal}
                                    initialMessage={``}
                                    clearForm={clearForm}
                                    contactForm={contactForm}
                                    handleInput={handleInput}
                                    inputBans={{comment:true}}
                                    width={width}
                                    country={country}
                                    secureInfo={true}
                                    dictionary={dictionary}
                                    customDictionary={customDictionary}
                                    buttonTitle={customDictionary.submit}
                                    // selectedCountry={selectedCountry}
                                    style={{ textAlign: 'center' }}
                                />
                            </div>
                        ) : (null)}
                    </div>

                      <div className={"WhatWeOfferLine"} >
                        <div className={"WhatWeOffer"} style={{ justifyContent: 'center' }}>
                            <div className={"WhatWeOfferLt"}>
                                <HOne align={"left"} title={customDictionary.what_we_offer} addclass="Title" />
                                <div className={"Offers"}>
                                    <div key={`Offer ${customDictionary.offer_1}`}>
                                        <div className={"Offer"}>
                                            <img src={vimg} alt="V" className={"Vimg"} />
                                            &nbsp;&nbsp;&nbsp;
                                            <div className={"TextBox"}>
                                                <div className={"Text"}>{customDictionary.offer_1}</div>

                                            </div>

                                        </div>

                                        <div className={"Separator"}>
                                        </div>
                                    </div>

                                    <div key={`Offer ${customDictionary.offer_2}`}>
                                        <div className={"Offer"}>
                                            <img src={vimg} alt="V" className={"Vimg"} />
                                            &nbsp;&nbsp;&nbsp;
                                            <div className={"TextBox"}>
                                                <div className={"Text"}>{customDictionary.offer_2}</div>

                                            </div>

                                        </div>

                                        <div className={"Separator"}>
                                        </div>
                                    </div>

                                    <div key={`Offer ${customDictionary.offer_3}`}>
                                        <div className={"Offer"}>
                                            <img src={vimg} alt="V" className={"Vimg"} />
                                            &nbsp;&nbsp;&nbsp;
                                            <div className={"TextBox"}>
                                                <div className={"Text"}>{customDictionary.offer_3}</div>

                                            </div>

                                        </div>

                                        <div className={"Separator"}>
                                        </div>
                                    </div>

                                    <div key={`Offer ${customDictionary.offer_4}`}>
                                        <div className={"Offer"}>
                                            <img src={vimg} alt="V" className={"Vimg"} />
                                            &nbsp;&nbsp;&nbsp;
                                            <div className={"TextBox"}>
                                                <div className={"Text"}>{customDictionary.offer_4}</div>

                                            </div>

                                        </div>

                                        <div className={"Separator"}>
                                        </div>
                                    </div>

                                    <div key={`Offer ${customDictionary.offer_5}`}>
                                        <div className={"Offer"}>
                                            <img src={vimg} alt="V" className={"Vimg"} />
                                            &nbsp;&nbsp;&nbsp;
                                            <div className={"TextBox"}>
                                                <div className={"Text"}>{customDictionary.offer_5}</div>

                                            </div>

                                        </div>

                                        <div className={"Separator"}>
                                        </div>
                                    </div>


                                </div>
                            </div>

                           {/* <div className={"WhatWeOfferRt"}>
                                <img src={time_to_act} id='PhotoHighLight' className='fixed-bottom' alt="Photo" />
                            </div> */}

                            {customDictionary.illustration_highlight.video != '' &&
                                <div className={"WhatWeOfferRt"}>
                                    <ReactPlayer
                                        className='react-player fixed-bottom Video'
                                        url={customDictionary.illustration_highlight.video}
                                        controls={true}
                                        config={{
                                            youtube: {
                                                playerVars: {
                                                    modestbranding: 1,
                                                    color: 'red'
                                                }
                                            },
                                        }}
                                        onPlay={() => {
                                            watcher.stopWatcher();
                                        }}
                                        onPause={() => {
                                            watcher.resumeWatcher();
                                        }}
                                    />
                                </div>
                            }
                            {
                                customDictionary.illustration_highlight.video == '' && customDictionary.illustration_highlight.picture != '' ?
                                    <div className={"WhatWeOfferRt"}>
                                        <img src={customDictionary.illustration_highlight.picture} id='PhotoHighLight' className='fixed-bottom' alt="Photo" />
                                    </div>
                                    : null
                            }
                        </div>
                    </div>

                    <div className={"ButtomForm"} id="ButtomForm">
                        <a href="#" name={"scrollForm"}></a>
                        <HOne addclass={"xsmall"} align={"center"} title={`${customDictionary.request}`} line={"none"} />
                        {/* <img src={logo} className={"ProjectLogo"} alt=""></img> */}
                        {customDictionary.urgency ?
                            <React.Fragment>
                                <svg xmlns="http://www.w3.org/2000/svg" width="138.247" height="2" viewBox="0 0 138.247 2">
                                    <defs>
                                        <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                            <stop offset="0" stopColor="#a96903" />
                                            <stop offset="0.258" stopColor="#aa6a02" />
                                            <stop offset="0.352" stopColor="#b07102" />
                                            <stop offset="0.418" stopColor="#b97d02" />
                                            <stop offset="0.472" stopColor="#c78e01" />
                                            <stop offset="0.518" stopColor="#daa401" />
                                            <stop offset="0.557" stopColor="#f0be00" />
                                            <stop offset="0.579" stopColor="#ffd100" />
                                            <stop offset="1" stopColor="#a96903" />
                                        </linearGradient>
                                    </defs>
                                    <g id="Сгруппировать_94" data-name="Сгруппировать 94" transform="translate(-2822.173 274.933)">
                                        <rect id="Прямоугольник_18" data-name="Прямоугольник 18" width="138.247" height="2" transform="translate(2822.173 -274.933)" fill="url(#linear-gradient)" />
                                    </g>
                                </svg>
                                <div className={"FormText"}>
                                    {customDictionary.urgency}
                                </div>
                            </React.Fragment>
                            : (null)
                        }
                        <UserForm
                            className={mobileVerison ? "MobileMessageModal" : ""}
                            thankModal={true}
                            clearForm={clearForm}
                            message={dictionary.thank_you_deal}
                            initialMessage={``}
                            country={country}
                            topPartRow={true}
                            contactForm={contactForm}
                            handleInput={handleInput}
                            width={width}
                            secureInfo={true}
                            inputBans={{comment:true}}
                            customDictionary={customDictionary}
                            dictionary={dictionary}
                            buttonTitle={customDictionary.submit}
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                        />

                     </div>
            </div>
    )
}

export default withRouter(customCampaignLogic(MiamiMovePage));